import type {
  InteractiveContent,
  RatingStaticContent,
} from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';

export const ratingGridToQuestionGrid = (
  interactiveContent: InteractiveContent,
  staticContent: RatingStaticContent,
): Question['grid'] => {
  if (interactiveContent.image) {
    return {
      id: interactiveContent.interactiveContentId,
      type: 'custom',
      cropped_image_url: interactiveContent.image.presets.original.url,
      image_alt_description: interactiveContent.image.altText ?? '',
      url: interactiveContent.image.presets.source.url,
      rotation: staticContent.interactiveContentStyling?.gridImageRotation ?? 0,
    } as Question['grid'];
  } else if (staticContent.interactiveContentStyling?.gridImageKey) {
    return {
      id: staticContent.interactiveContentStyling?.gridImageKey,
      type: 'default',
      rotation: staticContent.interactiveContentStyling?.gridImageRotation ?? 0,
    } as Question['grid'];
  }

  // Something is wrong. Default to default grid
  return {
    id: '2x2',
    type: 'default',
    rotation: 0,
  } as Question['grid'];
};
